import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { CouriersService } from '../../../../services/courier-services/couriers.service';
import { PackageOption } from '../../../../models/inModels/MarketPlaceModel';

@Component({
  selector: 'app-create-package',
  templateUrl: './create-package.component.html',
})
export class CreatePackageComponent implements OnInit {
  model: PackageOption;
  loading = false;
  error: Message[];
  messages: Message[];
  courierServiceId;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: CouriersService,) {
  }

  ngOnInit() {
    this.courierServiceId = this.route.snapshot.params.courierServiceId;
    this.model = new PackageOption();
    this.model.CourierServiceId = this.courierServiceId;
  }

  goBack(): void {
    this.router.navigate(['/marketplace/courier-services/edit', this.model.CourierServiceId]);
  }

  save() {
    this.loading = true;
    this.service.createPackageOption(this.model).then(
      res => {
        this.model = new PackageOption(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/courier-services/edit/create-package/create-package.component.ts